import { ClassFormCardCombinedProps } from './types';

const usePresenter = (props: ClassFormCardCombinedProps): ClassFormCardCombinedProps => {
  return props;
};

export default usePresenter;
